import { z } from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalFirestoreTimestamp,
} from '../shared/schema'

export const mimeTypeMapping: Record<string, string> = {
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  html: 'text/html',
  json: 'application/json',
  md: 'text/markdown',
  pdf: 'application/pdf',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  txt: 'text/plain',
}

export const supportedExtensions = Object.keys(mimeTypeMapping)

export const schema = z.object({
  fileLink: z.string(),
  fileName: z.string(),
  mimeType: z.string().optional(),
  fileStorageURL: z.string(),
  roomId: z.string(),
  userId: z.string(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const empty = Object.freeze(
  schema.parse({
    fileLink: '',
    fileName: '',
    fileStorageURL: '',
    roomId: '',
    userId: '',
    mimeType: '',
  })
)

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
})

export type FirestoreRoomStateFile = z.infer<typeof schema>
export type FirestoreRoomStateFileWrite = z.infer<typeof writeSchema>
